/** @format */

export const loadingSelector = (state) => state.dashboard.loading;
export const titleSelector = (state) => state.dashboard.filter.title;
export const countriesSelector = (state) => state.dashboard.filter.countries;
export const citiesSelector = (state) => state.dashboard.filter.cities;
export const selectedCountrySelector = (state) =>
	state.dashboard.filter.selectedCountry;
export const selectedCitiesSelector = (state) =>
	state.dashboard.filter.selectedCities;
export const meetupSelector = (state) => state.dashboard.meetups;
export const searchTitlesSelector = (state) =>
	state.dashboard.filter.searchTitles;
export const selectedTitleSelector = (state) => state.dashboard.filter.title;
